import { useEffect, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { SCOPES } from "../../contants";
import { SMALLLOGO } from "../../redux/types";
import PermissionGate from "../PermissionGate";
import useResponsive from "../../hooks/useResponsive";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { useSelector } from "react-redux";

function LeftSidebar({ sidebarData, sideMenuOpen, setSideMenuOpen }) {
  const [childMenuOpen, setChildMenuOpen] = useState(false);
  const { isFullScreen } = useSelector((state) => state.util);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useResponsive();
  const sidebarRef = useRef(null);

  useOnClickOutside(sidebarRef, () => setChildMenuOpen(false));

  const isActiveMenu = (data) => {
    if (data.link === pathname) return true;
    if (data.children && data.children.some((child) => child.link === pathname))
      return true;
    return false;
  };

  const activeValue =
    sidebarData && sidebarData.find((data) => isActiveMenu(data));

  useEffect(() => {
    if (!isMobile || sideMenuOpen) {
      setChildMenuOpen(activeValue?.children ? true : false);
    } else {
      setChildMenuOpen(false);
    }
  }, [activeValue, isMobile, sideMenuOpen]);

  const handleNavigate = (link) => navigate(link);

  const handleIconClickNavigate = (data) => {
    if (isActiveMenu(data)) {
      setChildMenuOpen(!childMenuOpen);
      return;
    }

    if (data?.link) {
      navigate(data.link);
      if (!data?.children) {
        setSideMenuOpen(false);
      }
    } else if (data?.children) {
      navigate(data.children[0].link);
    }
  };

  const renderMenuItems = (items) =>
    items.map((item, index) => (
      <li className="nav-item" key={index}>
        <a
          className={`nav-link ${item?.link === pathname ? "active" : ""}`}
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleNavigate(item.link);
            setChildMenuOpen(false);
            setSideMenuOpen(false);
          }}
        >
          <span className="w-100">{item.title}</span>
          {item.children && (
            <span className="menu-arrow">
              <i className="mdi mdi-chevron-right"></i>
            </span>
          )}
        </a>
        {item?.children && (
          <ul className="nav-second-level">{renderMenuItems(item.children)}</ul>
        )}
      </li>
    ));

  useEffect(() => {
    const handleOpenSidebar = () => setSideMenuOpen(true);
    window.addEventListener("open-sidebar", handleOpenSidebar);
    return () => window.removeEventListener("open-sidebar", handleOpenSidebar);
  }, [setSideMenuOpen]);

  return (
    <div className="leftbar-tab-menu" ref={sidebarRef}>
      {isMobile && sideMenuOpen && (
        <div
          className="sidebar-mobile-close-btn rounded-circle position-fixed bg-white border text-dark shadow d-flex align-items-center justify-content-center cursor-pointer"
          onClick={() => setSideMenuOpen(false)}
          style={{
            top: "24px",
            left: "57px",
            width: "25px",
            height: "25px",
            zIndex: 1050,
          }}
          title="Close menu"
        >
          <i
            className="mdi mdi-chevron-left font-weight-bold"
            style={{ fontSize: "18px" }}
          ></i>
        </div>
      )}
      <div
        className={`main-icon-menu ${isFullScreen && "d-none"} ${
          isMobile ? (sideMenuOpen ? "" : "active") : ""
        }`}
      >
        <a
          onClick={() => handleNavigate("/")}
          className="logo logo-metrica d-block text-center"
          style={{ cursor: "pointer" }}
          href="/"
        >
          <img
            src={SMALLLOGO}
            style={{ borderRadius: "100%" }}
            alt="logo-small"
            className="logo-sm"
          />
        </a>
        <nav className="nav">
          {sidebarData?.map((data, index) => (
            <OverlayTrigger
              key={index}
              placement="right"
              overlay={
                <Tooltip
                  id="tooltip-disabled"
                  className={!sideMenuOpen && isMobile ? "d-none" : "d-block"}
                >
                  {data.title}
                </Tooltip>
              }
            >
              <button
                className={`nav-link ${isActiveMenu(data) ? "active" : ""}`}
                onClick={() => {
                  handleIconClickNavigate(data);
                }}
                aria-label={data?.title}
                alt={data?.title}
              >
                <i
                  className={`align-self-center menu-icon icon-dual ${data.icon}`}
                ></i>
              </button>
            </OverlayTrigger>
          ))}
        </nav>
      </div>

      {activeValue?.children && childMenuOpen && (
        <div className="main-menu-inner">
          <div className="menu-body slimscroll">
            <div className="main-icon-menu-pane mm-active active">
              <div className="title-box">
                <h6 className="menu-title">{activeValue.title}</h6>
              </div>
              <ul className="nav">
                {activeValue.children.map((child, index) =>
                  child.permission ? (
                    <PermissionGate
                      key={index}
                      scopes={[SCOPES.BOOKING_SYSTEM]}
                    >
                      {renderMenuItems([child])}
                    </PermissionGate>
                  ) : (
                    renderMenuItems([child])
                  ),
                )}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LeftSidebar;
